import socialMediaCompiled from './socialmedia.hbs';
import facebookACompiled from './socialmedia.facebook.a.hbs';
import facebookBCompiled from './socialmedia.facebook.b.hbs';
import facebookCCompiled from './socialmedia.facebook.c.hbs';
import instagramACompiled from './socialmedia.instagram.a.hbs';
import instagramBCompiled from './socialmedia.instagram.b.hbs';
import twitterACompiled from './socialmedia.twitter.a.hbs';
import twitterBCompiled from './socialmedia.twitter.b.hbs';
import { Context } from './types';
import { TypeSafeTemplateDelegate } from '../../../Utility/Handlebars/types';
import './socialmedia.scss';

interface SocialMediaContext {
    announcement: {
        id: string | number;
    };
    widgetid: string | number;
}

export const socialMediaTemplate: TypeSafeTemplateDelegate<Context<SocialMediaContext>> =
    socialMediaCompiled;

interface AccountContext {
    announcement_id: string | number;
    announcement: {
        name: string;
    };
    width: number;
    height: number;
    image: string | null;
    max_img_width: number;
    message: string;
    bottom: number;
    pubDate: string;
}

interface FacebookAContext extends AccountContext {
    facebook_logo: string;
    logo: string;
}

export const facebookATemplate: TypeSafeTemplateDelegate<FacebookAContext> = facebookACompiled;
export const facebookBTemplate: TypeSafeTemplateDelegate<AccountContext> = facebookBCompiled;
export const facebookCTemplate: TypeSafeTemplateDelegate<AccountContext> = facebookCCompiled;

interface InstagramContext extends AccountContext {
    image: string;
}

export const instagramATemplate: TypeSafeTemplateDelegate<InstagramContext> = instagramACompiled;
export const instagramBTemplate: TypeSafeTemplateDelegate<InstagramContext> = instagramBCompiled;

interface TwitterAContext extends AccountContext {
    image: string;
    textstart: number;
    logo: string;
}

interface TwitterBContext extends AccountContext {
    image: string;
}

export const twitterATemplate: TypeSafeTemplateDelegate<TwitterAContext> = twitterACompiled;
export const twitterBTemplate: TypeSafeTemplateDelegate<TwitterBContext> = twitterBCompiled;
